import React, { useState } from 'react'

import CustomRangePicker from './CustomRangePicker'
import { getEndDate } from '../utils/DateTools'
import { Button, Popover } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faMinus } from '@fortawesome/pro-solid-svg-icons'

const PLUS_ICON_SIZE = '1x'
const BUTTONS_CONFIGURATION_ARRAY = [
  {
    title: 'week',
    displacement: { weeks: 1 }
  },
  {
    title: 'month',
    displacement: { months: 1 }
  }
]

const QuickDualDatePickers = ({ disabled, disabledEndDate, endDate, period, startDate, style, onDatesChange }) => {
  const [isButtonOpen, setIsButtonOpen] = useState(false)

  const handleDatesChange = dates => {
    if (onDatesChange) {
      onDatesChange(dates)
    }
  }

  const handlePopoverVisibilityChange = visible => {
    if (!visible) {
      setIsButtonOpen(false)
    }
  }

  const modifyEndDate = displacement => {
    const newEndDate = endDate.clone()

    getEndDate(newEndDate, displacement)

    handleDatesChange([startDate, newEndDate])
  }

  const datesButtons = (
    <div className='quick-popover-buttons-div'>
      {BUTTONS_CONFIGURATION_ARRAY.map(({ title, displacement }, index) => (
        <Button
          key={'period_button_' + index}
          type='primary'
          onClick={() => modifyEndDate(displacement)}
        >
          {title}
        </Button>
      ))}
    </div>
  )

  return (
    <div className='quick-move-buttons' style={style}>
      <CustomRangePicker
        startDate={startDate}
        endDate={endDate}
        period={period}
        onDatesChange={handleDatesChange}
        disabled={disabled}
        disabledEndDate={disabledEndDate}
      />
      <Popover
        placement='bottomLeft'
        content={datesButtons}
        visible={isButtonOpen}
        trigger='click'
        onVisibleChange={visible => handlePopoverVisibilityChange(visible)}
      >
        <Button
          type='primary'
          onClick={() => setIsButtonOpen(!isButtonOpen && !disabled && !disabledEndDate)}
          disabled={disabled || disabledEndDate}
        >
          <FontAwesomeIcon
            icon={isButtonOpen ? faMinus : faPlus}
            size={PLUS_ICON_SIZE}
          />
        </Button>
      </Popover>
    </div>
  )
}

export default QuickDualDatePickers
